/*  MUI  */
import { Box, Divider, Tabs } from '@mui/material';

/*  React  */
import React from 'react';

export const MUITabsWrapper = ({ children, ...rest }) => {
    const { className } = rest;
    return (
        <Box sx={{ marginBottom: '16px' }} className={className}>
            <Tabs
                centered
                indicatorColor="secondary"
                textColor="secondary"
                variant="fullWidth"
                {...rest}
            >
                {children}
            </Tabs>
            <Divider
                sx={{
                    border: '10px solid',
                    borderColor: 'tab.divider',
                    marginLeft: '2px',
                    marginRight: '2px',
                    opacity: 1
                }}
            />
        </Box>
    );
};

export const MUISubtabsWrapper = ({ children, ...rest }) => (
    <Box sx={{ marginBottom: '16px' }}>
        <Tabs {...rest}>{children}</Tabs>
    </Box>
);
